import { render, staticRenderFns } from "./CSCConfirmReceptionDlg.vue?vue&type=template&id=1f2cfb68"
import script from "./CSCConfirmReceptionDlg.vue?vue&type=script&lang=js"
export * from "./CSCConfirmReceptionDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports